'use client';

export { AnalyticsProvider } from '@sales-domain/analytics-react';
